import { mapGetters } from 'vuex'

export const MixinMaintenanceMode = {
  data() {
    return {
      showMaintenanceDialog: false
    }
  },
  computed: {
    ...mapGetters([
			'maintenanceMode'
		]),
  },
  watch: {
    maintenanceMode(value) {
      if (this.showMaintenanceDialog) {
        if (value) {
          this.onMaintenanceMode()
        } else {
          this.$store.dispatch('dialog/cancelDialog')
        }
      }
    }
  },
  methods: {
    async onMaintenanceMode({ callback = () => window.location.reload(), confirm = this.$t('orderbox.maintenance.reloadButton'), retry = false} = {}) {
      await this.$store.dispatch('dialog/cancelDialog')
      const confirmed = await this.$store.dispatch('dialog/showDialog', {
        title: this.$t('orderbox.maintenance.title'),
        message: this.$t('orderbox.maintenance.text'),
        confirm: retry ? this.$t('orderbox.maintenance.retryButton') : confirm,
      })
      if (confirmed) {
        callback?.()
      }
    },
    handleErrorDialog(err, { callback, retry, title, message, confirm } = {}) {
      if (err.isMaintenanceError) {
        if (callback) {
          retry = true
        }

        this.onMaintenanceMode({ callback, retry })
      } else {
        this.$store.dispatch('dialog/showDialog', {
          title: title ?? this.$t('forms.errors.error'),
          message: message ?? this.$t('forms.errors.generic'),
          confirm: confirm ?? 'OK',
        })
      }

    }
  },
  mounted() {
    if (this.maintenanceMode && this.showMaintenanceDialog) {
      this.onMaintenanceMode()
    }
  }
};

export default MixinMaintenanceMode;
